__webpack_require__.p = "/taqman/gene-expression/";